/* Vzuto — Size Guide «Як обрати розмір» (варіант D) interactivity.
   Event delegation on document → works regardless of when the popup is rendered
   or moved to #root by the theme, and tolerates duplicate modules. */
(function () {
  if (window.__vzSg) return;
  window.__vzSg = true;

  function num(v) { return parseFloat(String(v).replace(',', '.')); }

  // paint the violet fill to the left of the thumb (theme resets the native track)
  function setFill(r) {
    var min = num(r.min), max = num(r.max), v = num(r.value);
    var pct = max > min ? ((v - min) / (max - min)) * 100 : 50;
    r.style.setProperty('--vz-fill', pct.toFixed(2) + '%');
  }
  function initFills(root) {
    (root || document).querySelectorAll('[data-vz-sg-range]').forEach(setFill);
  }

  function sizesOf(root) {
    try {
      var s = JSON.parse(root.getAttribute('data-sizes') || '[]');
      if (!Array.isArray(s)) return [];
      s.sort(function (a, b) { return num(a.cm) - num(b.cm); });
      return s;
    } catch (e) { return []; }
  }

  // smallest size whose foot length >= measured (round up to fit), clamp to last
  function fitSize(sizes, cm) {
    for (var i = 0; i < sizes.length; i++) {
      if (num(sizes[i].cm) + 0.05 >= cm) return sizes[i];
    }
    return sizes[sizes.length - 1];
  }

  document.addEventListener('input', function (e) {
    var r = e.target && e.target.closest && e.target.closest('[data-vz-sg-range]');
    if (!r) return;
    var root = r.closest('[data-vz-sg]');
    if (!root) return;
    var sizes = sizesOf(root);
    if (!sizes.length) return;

    setFill(r);
    var cm = num(r.value);
    var fit = fitSize(sizes, cm);

    var val = root.querySelector('[data-vz-sg-val]');
    if (val) { val.textContent = cm.toFixed(1) + ' см'; val.classList.add('is-on'); }

    var prompt = root.querySelector('[data-vz-sg-prompt]');
    if (prompt) prompt.hidden = true;
    var filled = root.querySelector('[data-vz-sg-filled]');
    if (filled) filled.hidden = false;

    var eu = root.querySelector('[data-vz-sg-eu]'); if (eu) eu.textContent = fit.eu;
    var us = root.querySelector('[data-vz-sg-us]'); if (us) us.textContent = fit.us;
    var uk = root.querySelector('[data-vz-sg-uk]'); if (uk) uk.textContent = fit.uk;

    root.querySelectorAll('[data-vz-sg-row]').forEach(function (row) {
      var on = String(row.getAttribute('data-eu')) === String(fit.eu);
      row.classList.toggle('is-rec', on);
      var y = row.querySelector('.vz-sg-yours');
      if (y) y.hidden = !on;
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.vz-sg-acc__btn');
    if (!btn) return;
    var acc = btn.closest('.vz-sg-acc');
    if (!acc) return;
    var open = acc.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var body = acc.querySelector('.vz-sg-acc__body');
    if (body) body.hidden = !open;
  });

  // lock background scroll while open; unlock on ANY close (✕ / overlay / Esc) via observer
  function isShown(el) {
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0';
  }
  function watchPopup(title) {
    var pop = document.querySelector('.popup-a[data-title="' + title + '"]');
    if (!pop) return;
    function sync() {
      var open = isShown(pop);
      document.documentElement.classList.toggle('vz-sg-lock', open);
      if (!open && pop.__vzObs) { pop.__vzObs.disconnect(); pop.__vzObs = null; }
    }
    if (!pop.__vzObs) {
      pop.__vzObs = new MutationObserver(sync);
      pop.__vzObs.observe(pop, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    }
    sync();
  }

  // re-init the fill + lock when the size-guide opens (the popup gets moved to #root)
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-popup^="sizing-chart-popup-size-"]');
    if (t) {
      var title = t.getAttribute('data-popup');
      setTimeout(function () { initFills(); watchPopup(title); }, 80);
    }
  });

  // initial fill (default value) once the DOM is ready
  if (document.readyState !== 'loading') initFills();
  else document.addEventListener('DOMContentLoaded', function () { initFills(); });
})();
